<template>
    <div class="inner-wrap">
        <div class="left" :style="{'height': height}">
            <h1>Upload Your Trademark Images and Files</h1>
            <div class="list">
                <div v-for="(v, k) in form_data.trademark" :key="`tra` + k" class="item">
                    <Upload
                            :action="upload_url" :data="{ dir: 'template' }"
                            :on-success="(response, file, fileList) =>handleSuccess(response,file,fileList,'trademark',k,'file')"
                            :show-upload-list="false"
                    >
                        <template v-if="!!!v.raw">
                            <div class="upload-wrap cursor">
                                <img class="icon-upload" src="@/assets/images/design/icon-upload-pink.png"/>
                                <p> Click to Upload Trademark Image/File</p>
                            </div>
                        </template>
                        <template v-else-if="util.test_image(v.raw)">
                            <img :src="v.raw" class="" style="height: 100px" v-viewer />
                        </template>
                        <template v-else>
                            <a class="doc-wrap" target="_blank" :href="v.raw">
                                <img :src="util.get_image_icon(v.raw_name)" class="icon-doc" />
                                <span>{{v.raw_name}}</span>
                            </a>
                        </template>
                    </Upload>
                    <div class="bz">
                        <label >Remarks:</label>
                        <input :value="form_data.trademark[k].content" @input="input($event, 'trademark', k)"  placeholder="Please enter remarks" />
                    </div>
                    <img src="@/assets/images/design/icon-del2.png" alt="" class="icon-del cursor" @click.stop="del_trademark(k)">
                </div>
                <div class="btn btn-continue cursor" @click="add_trademark">+ Add Trademark Image</div>
            </div>
        </div>


        <div class="right">
            <Lesson v-if="is_lesson_show"></Lesson>
        </div>

    </div>
</template>

<script>
    import util from '@/utils/util'
    import {mapState} from 'vuex'
    import Lesson from "./Lesson.vue";
    export default {
        name: "Trademark",
        data() {
            return {
                upload_url: process.uniEnv.BASE_API + "/util/upload-image",
                util: util
            }
        },
        components: {
            Lesson
        },
        computed: {
            ...mapState({
                form_data: (state) => state.design.form_data,
                height: (state) => state.design.height,
                is_lesson_show: (state) => state.design.is_lesson_show,
            }),
        },
        methods: {
            add_trademark() {
                let object = {image: "", content: "", raw: "", raw_name: "",}
                this.$store.commit("design/arr_push_one", {key: 'trademark', value: object})
            },
            del_trademark(k) {
                this.$store.commit('design/arr_remove_one', {key: 'trademark', index: k})
            },
            input($event, field, k) {
                let object = this.form_data[field][k]
                object.content = $event.target.value
                this.$store.commit('design/arr_update_one', {key: field, index: k, value: object})
            },
            handleSuccess(response, file, fileList, field, k, child_field) {
                let object = this.form_data[field][k]
                if (child_field === "file") {
                    object.raw = response.data.url;
                    object.raw_name = file.name;
                } else if (child_field === "image") {
                    object.image = response.data.url;
                }
                this.$store.commit('design/arr_update_one', {key: field, index: k, value: object})
            },
        },
    }
</script>

<style lang="scss" scoped>
    .inner-wrap {
        display: flex;
        flex-wrap: nowrap;
        .left {
            padding: 0 30px 100px 30px;
            width: 490px;
            background: white;
            overflow: auto;
            h1 {
                width: 100%;
                height: 20px;
                line-height: 20px;
                font-size: 18px;
                color: #000000;
                border-left: 2px solid black;
                padding-left: 10px;
                margin: 15px 0;
            }
            .list {
                display: flex;
                flex-wrap: wrap;
                margin: 10px 0;
                .item {
                    position: relative;
                    width: 420px;
                    padding: 10px;
                    margin-bottom: 25px;
                    background: #FAFAFA;
                    .upload-wrap {
                        width: 418px;
                        height: 140px;
                        display: flex;
                        flex-wrap: wrap;
                        align-content: center;
                        justify-content: center;
                        .icon-upload {
                            width: 24px;
                            height: 24px;
                        }
                        p {
                            width: 100%;
                            margin-top: 5px;
                            color: #FA3D5A;
                            text-align: center;
                        }
                    }
                    .doc-wrap {
                        display: flex;
                        flex-wrap: nowrap;
                        align-items: center;
                        .icon-doc {
                            width: 24px;
                            height: 24px;
                            margin:0 10px;
                        }
                    }
                    .bz {
                        background: white;
                        display: flex;
                        flex-wrap: nowrap;
                        align-items: center;
                        height: 50px;
                        margin-top: 16px;
                        label {
                            font-size: 13px;
                            margin-left: 10px;
                        }
                        input {
                            height: 50px;
                            line-height: 50px;
                            background: white;
                            border: none;
                            outline: none;
                        }
                    }

                    .icon-del {
                        position: absolute;
                        top: 0;
                        right: 0;
                        width: 25px;
                        height: 25px;
                        z-index: 1000;
                    }
                }

                .btn-continue {
                    width: 420px;
                    height: 55px;
                    line-height: 55px;
                    color: #666666;
                    font-size: 14px;
                    text-align: center;
                    margin: 10px 0;
                    border-radius: 10px;
                    border: 1px solid #ccc;
                }
            }

        }
        .right {
            margin: 0 auto;
        }

    }

</style>
